import { Circle } from '@mui/icons-material';
import { Chip } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { EstateTaskInstanceStatus } from 'queries';

type Props = {
  estateTaskInstanceStatus: EstateTaskInstanceStatus;
};

const useStyles = makeStyles(() => ({
  status: {
    padding: '8px',
    gap: '6px',
    display: 'flex',
    height: '24px',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '12px',
    borderRadius: '100px',
  },
  statusChipBlack: {
    color: '#1C2541',
    backgroundColor: '#F9F9FB',
    fontSize: '12px',
    fontWeight: 'bold',
    lineHeight: '13px',
  },
  statusChipYellow: {
    color: '#BE5C23',
    backgroundColor: '#FFFAEB',
    fontSize: '12px',
    fontWeight: 'bold',
    lineHeight: '13px',
  },
  statusChipGreen: {
    color: '#000000',
    backgroundColor: '#03C04A',
    fontSize: '12px',
    fontWeight: 'bold',
    lineHeight: '13px',
  },
}));

const sx = {
  statusChipBlackDot: { '&&': { color: '#434E59', width: '6px', height: '6px' } },
  statusChipYellowDot: { '&&': { color: '#F79009', width: '6px', height: '6px' } },
  statusChipGreenDot: { '&&': { color: '#0FA65F', width: '6px', height: '6px' } },
};

const UnassignedTaskStatus = ({ estateTaskInstanceStatus }: Props) => {
  const classes = useStyles();

  if (estateTaskInstanceStatus === EstateTaskInstanceStatus.Unassigned) {
    return (
      <Chip
        className={classes.statusChipBlack}
        icon={<Circle sx={sx.statusChipBlackDot} />}
        label="Not Started"
        size="small"
      />
    );
  } else if (estateTaskInstanceStatus === EstateTaskInstanceStatus.Assigned) {
    return (
      <Chip
        className={classes.statusChipYellow}
        icon={<Circle sx={sx.statusChipYellowDot} />}
        label="Under Review"
        size="small"
      />
    );
  } else if (estateTaskInstanceStatus === EstateTaskInstanceStatus.Completed) {
    return (
      <Chip
        className={classes.statusChipGreen}
        icon={<Circle sx={sx.statusChipGreenDot} />}
        label="Completed"
        size="small"
      />
    );
  } else {
    return <></>;
  }
};

export default UnassignedTaskStatus;
